/**
 * Read-only thread summary display. Generation is background (living record);
 * UI no longer exposes manual generate/regenerate controls.
 */
import { cn } from '@/lib/utils'

export type ThreadSummaryViewProps = {
  summary: string | null | undefined
  variant?: 'inline' | 'card'
  className?: string
  emptyLabel?: string
}

export function ThreadSummaryView({
  summary,
  variant = 'inline',
  className,
  emptyLabel = 'Summary will appear as this thread develops.',
}: ThreadSummaryViewProps) {
  const text = summary?.trim()

  if (variant === 'card') {
    return (
      <div className={cn('space-y-2', className)}>
        {text ? (
          <p className="whitespace-pre-wrap text-sm leading-relaxed text-foreground/90">{text}</p>
        ) : (
          <p className="text-sm text-muted-foreground">{emptyLabel}</p>
        )}
      </div>
    )
  }

  return (
    <div className={cn('min-h-[1.25rem]', className)}>
      {text ? (
        <p className="whitespace-pre-wrap text-sm leading-snug text-muted-foreground">{text}</p>
      ) : null}
    </div>
  )
}

interface ThreadSummaryProps {
  summary: string | null
  variant?: 'inline' | 'card'
  className?: string
  emptyLabel?: string
  /** @deprecated Ignored — summaries are auto-generated. */
  threadId?: string
  /** @deprecated Ignored. */
  onChange?: (summary: string) => void
  /** @deprecated Ignored. */
  showEmptyTrigger?: boolean
}

export function ThreadSummary({
  summary,
  variant = 'inline',
  className,
  emptyLabel,
}: ThreadSummaryProps) {
  return (
    <ThreadSummaryView
      summary={summary}
      variant={variant}
      className={className}
      emptyLabel={emptyLabel}
    />
  )
}
